import type { FunctionComponent, PropsWithChildren } from 'react';
import MonarchSection from '~/cohesion/Monarch/MonarchSection';
import { everydaySansFont } from '~/styles/fonts/everydaySans';
import styles from './Layout.module.scss';
import { AAStickyMobileCTASkeleton, HeaderSkeleton } from '../shared/Skeleton';
import headerStyles from './Header/Header.module.scss';
import Footer from './Footer';
import SlimmedNavbar from '../editable/SlimmedNavbar';
import HoveringStickyMobileCTA from '../editable/HoveringStickyMobileCTA';
import { MonarchSlot } from '@redventures/cohesion-utils-react';

interface LayoutProps extends PropsWithChildren {
  signInButton?: boolean;
  url?: string;
}

const Layout: FunctionComponent<LayoutProps> = ({
  children,
  signInButton = false,
  url,
}) => (
  <div className={everydaySansFont.className}>
    <div className={headerStyles.stickyWrapper}>
      <MonarchSection elementPosition='NAVBAR'>
        <MonarchSlot fallback={<HeaderSkeleton />} slotId='navbar'>
          <SlimmedNavbar signInButton={signInButton} CTAButtonLink={url} />
        </MonarchSlot>
      </MonarchSection>
    </div>
    {/* Sub Navbar */}
    <MonarchSection elementPosition='SUB_NAVBAR'>
      <MonarchSlot slotId='subNavbar'>{null}</MonarchSlot>
    </MonarchSection>
    <main>{children}</main>

    {/* Footer */}
    <MonarchSection elementPosition='FOOTER'>
      <MonarchSlot slotId='footer'>
        <Footer />
      </MonarchSlot>
    </MonarchSection>

    {/* Bottom Sticky Section */}
    <div className={styles.stickyWrapper}>
      <MonarchSection elementPosition='BOTTOM_STICKY_SECTION'>
        <MonarchSlot
          fallback={<AAStickyMobileCTASkeleton />}
          slotId='bottomStickySection'
        >
          <HoveringStickyMobileCTA CTAButtonLink={url} />
        </MonarchSlot>
      </MonarchSection>
    </div>
  </div>
);

export default Layout;
